import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import { CartProvider } from "@/context/CartContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import FeedbackTab from "@/components/FeedbackTab";
import ThemePrompt from "@/components/ThemePrompt";

import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import BookDetail from "@/pages/BookDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Library from "@/pages/Library";
import Orders from "@/pages/Orders";
import Referrals from "@/pages/Referrals";
import Favorites from "@/pages/Favorites";
import Cart from "@/pages/Cart";
import Read from "@/pages/Read";
import Author from "@/pages/Author";
import Highlights from "@/pages/Highlights";
import GiftClaim from "@/pages/GiftClaim";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import Subscribe from "@/pages/Subscribe";
import Unsubscribe from "@/pages/Unsubscribe";
import Admin from "@/pages/Admin";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Privacy from "@/pages/Privacy";
import Cookies from "@/pages/Cookies";

const TOASTER_OPTIONS = {
  unstyled: false,
  classNames: {
    toast: "!bg-paper !text-ink !border !border-edge !rounded-none !font-sans",
    title: "!text-ink",
    description: "!text-muted_ink",
    actionButton: "!bg-terracotta !text-white !rounded-none !text-[10px] !uppercase !tracking-widest !px-3 !py-1.5",
    cancelButton: "!bg-transparent !text-muted_ink !border !border-edge !rounded-none !text-[10px] !uppercase !tracking-widest !px-3 !py-1.5",
  },
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <ThemeProvider>
        <AuthProvider>
          <FavoritesProvider>
          <CartProvider>
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/book/:id" element={<BookDetail />} />
              <Route path="/author/:slug" element={<Author />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/collections/:slug" element={<CollectionDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/gift/:token" element={<GiftClaim />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/library" element={
                <ProtectedRoute><Library /></ProtectedRoute>
              } />
              <Route path="/read/:id" element={
                <ProtectedRoute><Read /></ProtectedRoute>
              } />
              <Route path="/highlights" element={
                <ProtectedRoute><Highlights /></ProtectedRoute>
              } />
              <Route path="/orders" element={
                <ProtectedRoute><Orders /></ProtectedRoute>
              } />
              <Route path="/referrals" element={
                <ProtectedRoute><Referrals /></ProtectedRoute>
              } />
              <Route path="/favorites" element={
                <ProtectedRoute><Favorites /></ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute adminOnly><Admin /></ProtectedRoute>
              } />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cookies" element={<Cookies />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
            </Routes>
          </main>
          <Footer />
          <FeedbackTab />
          <ThemePrompt />
          <Toaster position="top-right" toastOptions={TOASTER_OPTIONS} />
          </CartProvider>
          </FavoritesProvider>
        </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
